import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { TabGroup, Tab, Select } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { HasPermissionDirective } from '../../../organizations/directives/has-permission';

@Component({
  selector: 'app-settings-nav',
  imports: [
    TabGroup,
    RouterLink,
    RouterLinkActive,
    Tab,
    NgIcon,
    Select,
    TranslocoPipe,
    HasPermissionDirective,
  ],
  templateUrl: './settings-nav.html',
})
export class SettingsNav {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);

  protected onSelectChange(url: string | string[] | null): void {
    this.router.navigate([url], {
      relativeTo: this.activatedRoute,
    });
  }
}
